import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { ChevronIcon } from '../icons'
import styles from './styles'
import { colors } from '../../styles'

const ChevronLink = ({
  children,
  color,
  uppercase,
  ...props
}) => (
  <Fragment>
    <a {...props}>
      <span className="ChevronLink">
        {children} <ChevronIcon width={12} height={12} />
      </span>
    </a>
    <style jsx>{styles}</style>
    <style jsx>{`
      .ChevronLink {
        color: ${color};
        text-transform: ${uppercase ? 'uppercase' : 'initial'};
      }
    `}
    </style>
  </Fragment>
)

ChevronLink.propTypes = {
  color: PropTypes.string,
  uppercase: PropTypes.bool,
  children: PropTypes.string.isRequired,
}

ChevronLink.defaultProps = {
  color: colors.darkPurple,
  uppercase: false,
}

export default ChevronLink
